import { ChangeDetectionStrategy, Component, ViewChild } from "@angular/core";
import { Listbox } from "primeng/listbox";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { DynamicControlComponent } from "../../dynamic-control-component.model";
import { CheckboxGroup } from "./checkbox-group.model";

@Component({
  selector: "form-checkbox-group",
  templateUrl: "./checkbox-group.component.html",
  styleUrls: ["./checkbox-group.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxGroupComponent extends DynamicControlComponent<CheckboxGroup> {
  @ViewChild(Listbox, { static: true }) primeListbox: Listbox;

  get optionText(): string {
    return "text";
  }

  get options(): any[] {
    return this.model.options;
  }

  get hasOptions(): boolean {
    return ArrayHelper.isAvailable(this.options);
  }

  get primeAllChecked(): boolean {
    return this.primeListbox != null && this.primeListbox.allChecked;
  }

  get enableToggleButton(): boolean {
    return this.control.enabled && !this.model.isAdmin;
  }

  get toggleButtonText(): string {
    return this.primeAllChecked ? "Deselect All" : "Select All";
  }

  toggleAll(event): void {
    this.primeListbox.toggleAll(event);
  }

  get classes(): string {
    return this.getClasses("checkbox-group");
  }
}
